<div class="wallet-container" *ngIf="!hasAutomaticPayoutEnabled">
  <div *ngIf="isUpdating" class="updating-overlay">
    <div class="updating-box">
      <div class="spinner"></div>
      <span class="updating-text">Updating your wallet, please wait...</span>
    </div>
  </div>

  <div class="title">My Wallet</div>

  <div class="wallet-card">
    <div class="wallet-balance">
      <div class="balance-label">Tokens</div>
      <div class="available-balance-value">
        <span class="token-count">{{ availableBalance }}</span>
        <span class="token-label">Available</span>
      </div>
      <div class="parity">1 Token = 1 Rupee</div>
    </div>
    <div class="wallet-logo">
      <img src="assets/hygge_coin_logo.svg" alt="hygge coin Logo" />
    </div>
  </div>

  <div class="wallet-actions">
    <button class="buy-button" (click)="openBuyTokensModal()">
      Buy Tokens
    </button>
    <button class="redeem-button" (click)="openRedeemTokensModal()">
      Redeem Tokens
    </button>
  </div>

  <div class="transaction-history">
    <div class="transaction-history-top">
      <div class="image-wrapper-transaction">
        <img class="orange-cirlce" src="assets/rectangle.svg" alt="orange_circle" />
        <img class="clock-hands" src="assets/clock_hands.svg" alt="orange_circle" />
        <img class="clock" src="assets/clock.svg" alt="clock" />
      </div>
      <div class="transaction-history-title">Transaction History</div>
    </div>

    <div class="table-wrapper">
      <table>
        <thead>
          <tr>
            <th class="type-column">Type</th>
            <th>Amount</th>
            <th>Status</th>
            <th>Date</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="transactionsLoading && (!transactions || transactions.length === 0)">
            <td colspan="4" class="loading-row">Loading transactions…</td>
          </tr>
          <tr *ngFor="let tx of transactions">
            <td>{{ tx.transaction_type }}</td>
            <td class="transaction-amount"><span>{{ tx.amount }}</span></td>
            <td class="transaction-status">
              <span class="status-dot" [ngClass]="{
                  completed: tx.status === 'COMPLETED',
                  pending: tx.status === 'PENDING',
                  failed: tx.status === 'FAILED',
                  released: tx.status === 'RELEASED',
                  redeemed: tx.status === 'REDEEMED'
                }"></span>
              {{ tx.status }}
            </td>
            <td>{{ tx.created_on | date : "dd-MM-yyyy" }}</td>
          </tr>
          <tr *ngIf="!transactionsLoading && (!transactions || transactions.length === 0)">
            <td colspan="4" class="no-transactions">No transactions to show.</td>
          </tr>
        </tbody>
      </table>
    </div> <div class="pagination-controls" *ngIf="totalPages && totalPages > 1">
      <div class="page-info">
        Showing
        <strong>{{ ((currentPage - 1) * limit) + 1 }}</strong>
        to
        <strong>{{ Math.min(currentPage * limit, totalItems) }}</strong>
        of <strong>{{ totalItems }}</strong>
      </div>
      <div class="controls">
        <button (click)="prevPage()" [disabled]="currentPage === 1">Prev</button>
        <div class="page-buttons-wrapper">
          <ng-container *ngFor="let p of pages">
            <button class="page-btn" [class.active]="currentPage === p" (click)="goToPage(p)">
              {{ p }}
            </button>
          </ng-container>
        </div>
        <button (click)="nextPage()" [disabled]="currentPage === totalPages">Next</button>
      </div>
    </div>
  </div>
</div>

<div class="transaction-container-second" *ngIf="hasAutomaticPayoutEnabled">
  <div class="transaction-history">
    <div class="transaction-history-top">
        </div>

    <div class="table-wrapper-second">
      <table>
        <thead>
          <tr>
            <th class="type-column">Type</th>
            <th>Amount</th>
            <th>Status</th>
            <th>Date</th>
          </tr>
        </thead>
        <tbody>
            </tbody>
      </table>
    </div> <div class="pagination-controls" *ngIf="totalPages && totalPages > 1">
      <div class="page-info">
        Showing
        <strong>{{ ((currentPage - 1) * limit) + 1 }}</strong>
        to
        <strong>{{ Math.min(currentPage * limit, totalItems) }}</strong>
        of <strong>{{ totalItems }}</strong>
      </div>
      <div class="controls">
        <button (click)="prevPage()" [disabled]="currentPage === 1">Prev</button>
        <div class="page-buttons-wrapper">
          <ng-container *ngFor="let p of pages">
            <button class="page-btn" [class.active]="currentPage === p" (click)="goToPage(p)">
              {{ p }}
            </button>
          </ng-container>
        </div>
        <button (click)="nextPage()" [disabled]="currentPage === totalPages">Next</button>
      </div>
    </div>
  </div>
</div>